import React, { useEffect, useState } from "react";
import { IoIosAddCircle } from "react-icons/io";
import Options from "../../components/products/Options";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../lib/axios";
import { Link } from "react-router-dom";
import Delete from "../../components/Delete";
import { showCreateForm } from "../../redux/features/ProductSlice";
import EditMaterial from "../../components/materials/EditMaterial";
import Select from "react-select";
import { debounce } from "lodash";
import CreateProduct from "../../components/products/CreateProduct";
import EditProduct from "../../components/products/EditProduct";

function ProductList() {
  const [products, setProducts] = useState([]);
  const deleteItem = useSelector((state) => state.delete.item);
  const editObj = useSelector((state) => state.product.editObj);
  const createForm = useSelector((state) => state.product.createForm);
  const [categories, setCategories] = useState([
    { name: "همه", active: false, en: "all" },
    { name: " موجودی", active: true, en: "exist" },
    { name: "رو به اتمام", active: false, en: "finished" },
  ]);
  const [search, setSearch] = useState("");
  const [records, setRecords] = useState(10);
  const [url, setUrl] = useState(`/api/products`);
  const [pCategories, setPCategories] = useState([]);
  const [pCategory, setPCategory] = useState(null);
  const [colors, setColors] = useState([]);
  const [color, setColor] = useState(null);
  const [codes, setCodes] = useState([]);
  const [code, setCode] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    getPCategories();
    getColors();
    getCodes();
  }, []);

  useEffect(() => {
    if (!deleteItem.id && !createForm && !editObj) {
      getProducts();
    }
  }, [
    categories,
    deleteItem,
    records,
    url,
    pCategory,
    color,
    createForm,
    editObj,
    code,
  ]);

  const delayedSearch = debounce(() => {
    getProducts();
    console.log("workingg");
  }, 5000);

  useEffect(() => {
    let delaySearch;
    const handleSearchDelay = () => {
      delaySearch = setTimeout(() => {
        console.log(`Performing search for: ${search}`);
        getProducts();
      }, 800);
    };
    const handleKeyUp = () => {
      if (delaySearch) {
        clearTimeout(delaySearch);
      }
      handleSearchDelay();
    };
    handleKeyUp();
    return () => {
      clearTimeout(delaySearch);
    };
  }, [search]);

  const getPCategories = () => {
    axios.get(`/api/settings/product/category/select2`).then((data) => {
      setPCategories(data);
    });
  };

  const getColors = () => {
    axios.get(`/api/settings/colors/select2`).then((data) => {
      setColors(data);
    });
  };

  const getCodes = () => {
    axios.get(`/api/settings/code/select2`).then((data) => {
      setCodes(data);
    });
  };

  const getProducts = () => {
    console.log(code);
    axios
      .post(url, {
        category: categories.find((row) => row.active === true).en,
        search,
        records,
        pCategory,
        color,
        code,
      })
      .then((data) => {
        setProducts(data);
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateCategory = (index) => {
    setCategories((prevCategories) => {
      const updatedCategories = prevCategories.map((row, i) => {
        if (index === i) {
          return { ...row, active: true };
        }
        return { ...row, active: false };
      });

      return updatedCategories;
    });
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row bg-slate-50 border justify-between py-2 px-4">
        <h3>گدام محصولات</h3>
        <div className="flex gap-6 ">
          {categories.map((row, index) => (
            <button
              key={index}
              onClick={() => updateCategory(index)}
              className={` rounded-sm  border border-blue-300 px-2 ${
                row.active
                  ? "bg-blue-300 text-gray-700"
                  : "text-blue-300 hover:text-blue-500 hover:border-blue-500 hover:bg-gray-100"
              }`}
              disabled={row.active ? true : false}
            >
              {row.name}
            </button>
          ))}
          <button
            onClick={() => dispatch(showCreateForm())}
            className="flex bg-sky-500 text-white rounded-sm py-1 px-2 hover:bg-sky-700 hover:font-semibold"
          >
            <IoIosAddCircle className="ml-1" size={22} />
            اضافه کردن
          </button>
        </div>
      </div>
      <div className="p-4">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-9 gap-4 mt-8">
          <select
            onChange={(e) => setRecords(e.target.value)}
            className="ring-1 ring-inset ring-gray-300  mb-3 px-4 py-2 rounded-md"
          >
            <option className="p-0 m-0" value={10}>
              10
            </option>
            <option className="p-0 m-0" value={20}>
              20
            </option>
            <option className="p-0 m-0" value={50}>
              50
            </option>
            <option className="p-0 m-0" value={100}>
              100
            </option>
            <option className="p-0 m-0" value={500}>
              500
            </option>
          </select>

          <Select
            placeholder="نوع محصول"
            required
            onChange={(e) => setPCategory(e ? e.value : null)}
            isClearable={true}
            options={pCategories}
            styles={{
              control: (provided) => ({
                ...provided,
                padding: "0.2rem", // Adjust the padding value as needed
              }),
            }}
          />
          <Select
            placeholder="کد"
            required
            onChange={(e) => setCode(e ? e.value : null)}
            isClearable={true}
            options={codes}
            styles={{
              control: (provided) => ({
                ...provided,
                padding: "0.2rem", // Adjust the padding value as needed
              }),
            }}
          />
          <Select
            placeholder="رنگ"
            required
            onChange={(e) => setColor(e ? e.value : null)}
            isClearable={true}
            options={colors}
            styles={{
              control: (provided) => ({
                ...provided,
                padding: "0.2rem", // Adjust the padding value as needed
              }),
            }}
          />
          {/* <input
            type="text"
            className="ring-1 ring-inset ring-gray-300  mb-3 px-4 py-2 rounded-md"
            value={search}
            placeholder="جستجو..."
            onChange={(e) => setSearch(e.target.value)}
          /> */}
        </div>
        <table className="table-auto w-full">
          <thead>
            <tr className="border-y">
              <th className="px-4 py-2 text-start">نوع محصول</th>
              <th className="px-4 py-2 text-start">#کد</th>
              <th className="px-4 py-2 text-start">رنگ</th>
              <th className="px-4 py-2 text-start">تعداد وارده</th>
              <th className="px-4 py-2 text-start">قیمت تمام شد</th>
              <th className="px-4 py-2 text-start">موجودی</th>
              <th className="px-4 py-2 text-start">عملیه ها</th>
            </tr>
          </thead>
          <tbody>
            {products?.data &&
              products?.data.map((row, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0 ? "bg-gray-100" : "bg-white"
                  } border`}
                >
                  <td className="px-4 py-2">{row.pname}</td>
                  <td className="px-4 py-2">{row.code}</td>
                  <td className="px-4 py-2">{row.cname}</td>
                  <td className="px-4 py-2">{row.qtys}</td>
                  <td className="px-4 py-2">{row.qty_price} دالر</td>
                  <td className="px-4 py-2">{row.exist_qtys}</td>
                  <td className="px-4 py-2">
                    <Options product={row} />{" "}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        <div className="flex gap-4 justify-end p-4">
          {products.links &&
            products.links.length > 3 &&
            products.links.map((row, index) => (
              <button
                key={index}
                disabled={row.active || row.url === null}
                onClick={() => setUrl(row.url)}
                className={`border py-1 px-3 ${
                  row.active ? "bg-blue-500 text-white" : "hover:bg-gray-300"
                }`}
              >
                <>{row.label}</>
              </button>
            ))}
          {createForm && <CreateProduct />}
          {editObj && <EditProduct />}
          {deleteItem.id && <Delete />}
        </div>
      </div>
    </div>
  );
}

export default ProductList;
